import React from "react";
import { Grid, Header } from "semantic-ui-react";
import Instrument from "../Instrument";
import { InstrumentType, TkrCusip } from "../../../types";
import currency from "currency.js";
import { displaySliceId } from "../../../utils/sliceFormat";
import Spinner from "../../Spinner";

interface Props {
  header: string;
  instrumentArray: InstrumentType[];
  tkrCusip: TkrCusip;
  isLoading: boolean;
}

const InstrumentBar = ({
  header,
  instrumentArray,
  tkrCusip,
  isLoading,
}: Props) => {
  const posQty = instrumentArray.find(
    (inst) => inst.reportType === "mtm-position-quantity"
  );
  const posAmt = instrumentArray.find(
    (inst) => inst.reportType === "mtm-position-amount"
  );
  const mtmReq = instrumentArray.find(
    (inst) => inst.reportType === "mtm-requirement"
  );
  const varReq = instrumentArray.find(
    (inst) => inst.reportType === "var-requirement"
  );

  return (
    <Grid padded>
      <Header as="h2">{`${header} - ${tkrCusip.tkr ? tkrCusip.tkr : ""} - ${
        posQty?.date ? posQty?.date : ""
      } - ${posQty?.slice ? displaySliceId(posQty?.slice) : ""}`}</Header>
      <Grid.Row stretched>
        <Spinner loading={isLoading} />
        <Grid.Column id="position-qty-col" computer={4}>
          <Instrument
            title={"Position Quantity"}
            value={posQty?.value ? `${Math.round(Number(posQty?.value))}` : "-"}
            change={
              posQty?.change
                ? `${Math.round(Number(posQty?.change))} ${Math.round(
                    Number(posQty?.changePercentage)
                  )}%`
                : "-"
            }
            high={posQty?.range ? `${Math.round(posQty?.range?.high)}` : "-"}
            low={posQty?.range ? `${Math.round(posQty?.range?.low)}` : "-"}
            sliceDetails={{ id: posQty?.slice, date: posQty?.date }}
          />
        </Grid.Column>
        <Grid.Column id="position-amount-col" computer={4}>
          <Instrument
            title={"Position Amount"}
            value={posAmt?.value ? currency(posAmt?.value).format() : "-"}
            change={
              posAmt?.change
                ? `${currency(posAmt?.change).format()} ${Math.round(
                    Number(posAmt?.changePercentage)
                  )}%`
                : "-"
            }
            high={posAmt?.range ? currency(posAmt?.range?.high).format() : "-"}
            low={posAmt?.range ? currency(posAmt?.range?.low).format() : "-"}
            sliceDetails={{
              id: posAmt?.slice,
              date: posAmt?.date,
            }}
          />
        </Grid.Column>
        <Grid.Column id="var-col" computer={4}>
          <Instrument
            title={"VAR"}
            value={varReq?.value ? currency(varReq?.value).format() : "-"}
            change={
              varReq?.change
                ? `${currency(varReq?.change).format()} ${Math.round(
                    Number(varReq?.changePercentage)
                  )}%`
                : "-"
            }
            high={varReq?.range ? currency(varReq?.range?.high).format() : "-"}
            low={varReq?.range ? currency(varReq?.range?.low).format() : "-"}
            sliceDetails={{ id: varReq?.slice, date: varReq?.date }}
          />
        </Grid.Column>
        <Grid.Column id="mtm-col" computer={4}>
          <Instrument
            title={"MTM"}
            value={mtmReq?.value ? currency(mtmReq?.value).format() : "-"}
            change={
              mtmReq?.change
                ? `${currency(mtmReq?.change).format()} ${Math.round(
                    Number(mtmReq?.changePercentage)
                  )}%`
                : "-"
            }
            high={mtmReq?.range ? currency(mtmReq?.range?.high).format() : "-"}
            low={mtmReq?.range ? currency(mtmReq?.range?.low).format() : "-"}
            sliceDetails={{ id: mtmReq?.slice, date: mtmReq?.date }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default InstrumentBar;
